module.exports = __webpack_public_path__ + "img/Link - dark.e749e6ff.svg";